<div class="h-full p-6 md:p-8 space-y-8 md:space-y-10 bg-[radial-gradient(circle_at_top_left,_rgba(37,99,235,0.08),_transparent_30%),radial-gradient(circle_at_top_right,_rgba(16,185,129,0.08),_transparent_28%)]">
  <section class="relative overflow-hidden rounded-[32px] border border-white/10 bg-[linear-gradient(135deg,#0f172a_0%,#1d4ed8_48%,#0f766e_100%)] p-7 md:p-8 text-white shadow-[0_24px_80px_rgba(15,23,42,0.28)]">
    <div class="absolute inset-0 opacity-20 bg-[radial-gradient(circle_at_20%_20%,white_0%,transparent_35%),radial-gradient(circle_at_80%_10%,white_0%,transparent_30%)]"></div>
    <div class="relative z-10">
      <div class="max-w-3xl">
        <div class="inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/10 px-3 py-1 text-xs font-medium uppercase tracking-[0.24em] text-white/80">
          <lucide-angular [img]="Sparkles" class="h-3.5 w-3.5"></lucide-angular>
          Bienvenido a BotSpace
        </div>
        <div class="mt-4 mb-5 hidden xl:flex items-center gap-3 text-sm text-white/75">
          <span class="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/8 px-3 py-1.5 backdrop-blur-sm">
            <lucide-angular [img]="Clock3" class="h-4 w-4"></lucide-angular>
            {{ totalRecentCount }} accesos recientes
          </span>
          <span class="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/8 px-3 py-1.5 backdrop-blur-sm">
            <lucide-angular [img]="Database" class="h-4 w-4"></lucide-angular>
            {{ recentKnowledgeBases.length }} KBs activas
          </span>
        </div>
        <h1 class="!mt-3 !mb-3 !text-white !leading-tight">
          Contin&uacute;a tu trabajo sin volver a buscarlo todo
        </h1>
        <p class="normal !mb-6 max-w-2xl !text-white/80">
          Reanuda conversaciones, entra a tus bases de conocimiento y vuelve a los asistentes
          que usaste recientemente desde un panel m&aacute;s &uacute;til y directo.
        </p>
        <div class="flex flex-wrap gap-3">
          <a
            routerLink="/chatbot"
            class="inline-flex items-center gap-2 rounded-xl bg-white px-5 py-3 font-semibold text-slate-900 shadow-lg transition-transform hover:-translate-y-0.5"
          >
            Explorar chatbots
            <lucide-angular [img]="ArrowRight" class="h-4 w-4"></lucide-angular>
          </a>
          <a
            routerLink="/knowledge-base"
            class="inline-flex items-center gap-2 rounded-xl border border-white/20 bg-white/10 px-5 py-3 font-semibold text-white backdrop-blur-sm transition-colors hover:bg-white/15"
          >
            Abrir bases de conocimiento
            <lucide-angular [img]="Database" class="h-4 w-4"></lucide-angular>
          </a>
        </div>
      </div>
    </div>
  </section>

  <section class="space-y-5">
    <div class="flex items-end justify-between gap-4">
      <div>
        <p class="mb-2 text-xs font-semibold uppercase tracking-[0.24em] text-light-text-tertiary dark:text-dark-text-tertiary">
          Prioridad
        </p>
        <h2 class="!mb-1">Contin&uacute;a donde quedaste</h2>
        <p class="normal !mb-0">
          Tus accesos m&aacute;s recientes combinados en una sola vista.
        </p>
      </div>
      <div class="flex items-center gap-3">
        <div class="hidden md:flex items-center gap-2 rounded-full border border-light-border dark:border-dark-border bg-light-surface dark:bg-dark-surface px-4 py-2 text-sm text-light-text-secondary dark:text-dark-text-secondary">
          <lucide-angular [img]="Clock3" class="h-4 w-4"></lucide-angular>
          {{ visibleRecentItemsCount }} elementos recientes
        </div>
        @if (hasMoreRecentItems) {
          <button
            type="button"
            (click)="toggleRecentItems()"
            class="rounded-xl border border-light-border dark:border-dark-border bg-light-surface dark:bg-dark-surface px-4 py-2 text-sm font-medium text-light-text dark:text-dark-text transition-colors hover:bg-light-bg dark:hover:bg-dark-bg"
          >
            {{ showAllRecentItems ? 'Ver menos' : 'Ver todo' }}
          </button>
        }
      </div>
    </div>

    @if (visibleRecentItems.length > 0) {
      <div class="grid gap-4 xl:grid-cols-[1.25fr_1fr]">
        @for (item of visibleRecentItems; track item.type + '-' + getItemSubtitle(item)) {
          <a
            [routerLink]="item.route"
            class="group relative overflow-hidden rounded-[24px] border border-light-border dark:border-dark-border bg-light-surface dark:bg-dark-surface p-5 shadow-sm transition-all duration-200 hover:-translate-y-1 hover:shadow-xl hover:border-light-primary/25 dark:hover:border-dark-primary/30"
            [class.xl:row-span-2]="$index === 0"
          >
            <div class="flex items-start gap-4">
              <div class="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-gradient-to-br text-white shadow-md" [class]="getItemSurfaceClass(item)">
                <lucide-angular [img]="getItemIcon(item)" class="h-6 w-6"></lucide-angular>
              </div>
              <div class="min-w-0 flex-1">
                <div class="mb-2 flex flex-wrap items-center gap-2">
                  <span class="rounded-full border border-light-border dark:border-dark-border bg-light-bg dark:bg-dark-bg px-2.5 py-1 text-[11px] font-medium uppercase tracking-[0.16em] text-light-text-secondary dark:text-dark-text-secondary">
                    {{ getItemTypeLabel(item) }}
                  </span>
                  <span class="text-xs text-light-text-tertiary dark:text-dark-text-tertiary">
                    {{ getRelativeTime(item.timestamp) }}
                  </span>
                </div>
                <p class="text-lg font-semibold text-light-text dark:text-dark-text !mb-1 truncate">
                  {{ getItemTitle(item) }}
                </p>
                <p class="text-sm text-light-text-secondary dark:text-dark-text-secondary truncate !mb-0">
                  {{ getItemSubtitle(item) }}
                </p>
              </div>
              <button
                (click)="deleteRecentItem($event, item)"
                class="rounded-full border border-light-border dark:border-dark-border bg-white/90 dark:bg-dark-surface/90 p-1.5 opacity-0 transition-all hover:bg-red-50 dark:hover:bg-red-900/30 group-hover:opacity-100"
                aria-label="Eliminar de recientes"
              >
                <lucide-angular [img]="X" class="h-4 w-4 text-light-text-tertiary dark:text-dark-text-tertiary hover:text-red-500"></lucide-angular>
              </button>
            </div>
          </a>
        }
      </div>
    } @else {
      <div class="rounded-[24px] border border-dashed border-light-border dark:border-dark-border bg-light-surface/80 dark:bg-dark-surface/80 p-10 text-center">
        <div class="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-2xl bg-light-bg dark:bg-dark-bg">
          <lucide-angular [img]="Sparkles" class="h-7 w-7 text-light-primary dark:text-dark-primary"></lucide-angular>
        </div>
        <h3 class="!mb-2">Todav&iacute;a no hay actividad reciente</h3>
        <p class="normal mx-auto max-w-xl !mb-5">
          A medida que abras chatbots, conversaciones o bases de conocimiento, esta zona
          se convertir&aacute; en tu punto de entrada m&aacute;s r&aacute;pido.
        </p>
        <div class="flex flex-wrap justify-center gap-3">
          <a
            routerLink="/chatbot"
            class="rounded-xl bg-light-primary px-4 py-2.5 font-medium text-white transition-opacity hover:opacity-90 dark:bg-dark-primary"
          >
            Ir a chatbots
          </a>
          <a
            routerLink="/knowledge-base"
            class="rounded-xl border border-light-border dark:border-dark-border bg-light-surface dark:bg-dark-surface px-4 py-2.5 font-medium text-light-text dark:text-dark-text transition-colors hover:bg-light-bg dark:hover:bg-dark-bg"
          >
            Ir a bases de conocimiento
          </a>
        </div>
      </div>
    }
  </section>
</div>
